import React, { useState } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { treeItemDataType, treeItemType } from '../_type';
import './index.scss';

const  removeThree =(arr:number [],targetVal:number) => {
  const newArray = arr.filter(item => item !== targetVal);
  return newArray;
};

const TreeItem = (props: treeItemType) => {
  const { tableInfo,treeIndex,selectedItems, setSelectedItems, } = props;
  const [isShow, setIsShow] = useState(false);


  return (
    <div className="dbl-tree-field_list">
      <div className="dbl-tree-field_list-bh">
        <div
          className="dbl-tree-bh-show"
          onClick={() => {
            if(!isShow) {
              setSelectedItems([...selectedItems,treeIndex]);
            } else {
              setSelectedItems(removeThree(selectedItems,treeIndex));
            }
            setIsShow(!isShow);
          }}
        >
          <SvgIcon type="point-down" className={isShow ? 'dbl-tree-bh-action' : 'dbl-tree-bh-change'} />
          <span className="dbl-tree-bh-text">{tableInfo?.table_name || '-'}</span>
        </div>
      </div>
      {(tableInfo.column_list || []).map((item: treeItemDataType, index) => (
        <div className={isShow ? 'dbl-tree-field_list-bd height-nomal' : 'dbl-tree-field_list-bd height-0'} key={index}>
          {item.name ? (
            <div className="bd-group">
              {/* <SvgIcon type={FieldClassIconNameMap[columnClass.name]} className="bd-icon" /> */}
              {/* {isEn ? item.name_en : item.name} */}
              <div className='dbl-tree-sql-name'>
                { item.name}
              </div>
              <div className='dbl-tree-sql-type'>
                { item.type}
              </div>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default TreeItem; 
